export default __webpack_public_path__ + "static/media/15.417928b3.jpeg";